import React, { Component } from "react"
import { graphql, Link } from "gatsby"

import SEO from "../components/seo"
import About from '../assets/images/about.jpg'

class ContactPage extends Component {

  render() {
    
    const { page } = this.props.data

    return (
      <>
        <SEO title={page.seo.title} bodyClass='about' description={page.seo.metaDesc} />
        <section className='page'>
          <div className='page__inner'>
            <div className='page__columns'>
              <div className='page__col'>
                <img src={page.About.about.image.sourceUrl} alt='Emily Gillis' />
              </div>
              <div className='page__col'>
                { page.About.about.title && <h1 className='page__title page__title'>{page.About.about.title}</h1> }
                <div dangerouslySetInnerHTML={{ __html: page.About.about.content }} />
              </div>
            </div>
          </div>
        </section>
      </>
    )
  }

}

export default ContactPage

export const contactQuery = graphql`
  query {
    page: wpPage(slug: { eq: "contact" }){
      title
      seo {
        title
        metaDesc
      }
      About {
        about {
          title
          content
          image {
            sourceUrl
          }
        }
      }
    }
  }
`

